import util from '../libs/util'
import {baseURL} from '../libs/ajax'

const post = util.ajax.post

const common = {}

// 需修改，这是模板
common.uploadImg = baseURL + '/img/uploadImg'

// 省份查询
common.provinceList = function (params) {
  return post('/project/provinceList', params)
}
// 城市查询
common.cityList = function (params) {
  return post('/project/cityList', params)
}
// 经销商树查询
common.listAgentTree = function (params) {
  return post('/common/listAgentTree', params)
}
// 区域树查询
common.listDistinctView = function (params) {
  return post('/common/listDistinctView', params)
}
// 车主姓名及车牌号码查询（车辆档案）
common.vehicleListByConditions = function (params) {
  return post('/vehicle/listByConditions', params)
}
// 车主姓名及车牌号码查询（除车辆档案意外）
common.orderListByConditions = function (params) {
  return post('/order/listByConditions', params)
}

export default common



// WEBPACK FOOTER //
// ./src/api/common.js